import {
    type DiscreteCondition,
    type MaxRangeCondition,
    type MediaQueryContextDescriptor,
    MediaQueryTarget,
    type MinRangeCondition,
} from './types';

const DEFAULT_MIN_RANGE: MinRangeCondition = {
    [MediaQueryTarget.Phablet]: false,
    [MediaQueryTarget.Tablet]: false,
    [MediaQueryTarget.Desktop]: false,
    [MediaQueryTarget.Widescreen]: false,
    [MediaQueryTarget.QuadHdY]: false,
    [MediaQueryTarget.Ultrawide]: false,
};

const DEFAULT_MAX_RANGE: MaxRangeCondition = {
    [MediaQueryTarget.Mobile]: false,
};

const DEFAULT_DISCRETE: DiscreteCondition = {
    [MediaQueryTarget.Landscape]: false,
    [MediaQueryTarget.PrefersReducedMotion]: false,
    [MediaQueryTarget.UsingMouse]: true,
};

export const DEFAULT_CONTEXT: MediaQueryContextDescriptor = {
    ...DEFAULT_MIN_RANGE,
    ...DEFAULT_MAX_RANGE,
    ...DEFAULT_DISCRETE,
    betweenBreakpoints(_min, _max) {
        return false;
    },
};
